(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function setupCartDrawerTrigger(header) {
    const cartLink = header.querySelector('[data-cart-drawer-trigger]');

    if (!cartLink || cartLink.dataset.cartDrawerTriggerBound === 'true') return;

    cartLink.dataset.cartDrawerTriggerBound = 'true';
    cartLink.addEventListener('click', (event) => {
      // The drawer already handles clicks inside #cart-icon-bubble.
      if (event.defaultPrevented) return;

      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer || typeof cartDrawer.open !== 'function') return;

      event.preventDefault();
      cartDrawer.open(cartLink);
    });
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      setupCartDrawerTrigger(this);
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      setupCartDrawerTrigger(this);
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tassilix-catalog"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tx-poster-catalog'))customElements.define('tx-poster-catalog',class extends HTMLElement{
  connectedCallback(){if(this.ready)return;this.ready=true;this.cards=[...this.querySelectorAll('[data-poster-collections]')];this.empty=this.querySelector('.tx-catalog-empty');this.select=this.closest('section').querySelector('[data-collection-select]');this.links=[...this.querySelectorAll('[data-format]')];this.reset=this.querySelector('[data-format-reset]');this.isFormat=this.dataset.formatCollection==='true';this.anime=this.isFormat?(new URL(location.href).searchParams.get('anime')||'all'):this.dataset.currentCollection;if(![...this.select.options].some(option=>option.dataset.handle===this.anime))this.anime='all';if(this.isFormat){this.select.value=[...this.select.options].find(option=>option.dataset.handle===this.anime).value;this.filterAnime()}this.updateLinks();this.select.addEventListener('change',()=>{this.anime=this.select.selectedOptions[0].dataset.handle||'all';if(this.isFormat){this.filterAnime();const url=new URL(location.href);if(this.anime==='all')url.searchParams.delete('anime');else url.searchParams.set('anime',this.anime);url.searchParams.delete('page');history.replaceState(null,'',url.href);this.updateLinks()}else{const url=new URL(this.select.value,location.origin);const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);location.assign(url.href)}})}
  updateLinks(){const preview=new URL(location.href).searchParams.get('preview_theme_id');this.links.forEach(link=>{const url=new URL(link.getAttribute('href'),location.origin);if(this.anime==='all')url.searchParams.delete('anime');else url.searchParams.set('anime',this.anime);if(preview)url.searchParams.set('preview_theme_id',preview);link.href=url.href});this.reset.href=this.select.value||this.select.options[0].value}
  filterAnime(){let shown=0;this.cards.forEach(card=>{card.hidden=this.anime!=='all'&&!card.dataset.posterCollections.split(' ').includes(this.anime);if(!card.hidden)shown++});this.empty.hidden=shown>0;this.querySelector('.tx-catalog-current').textContent=this.dataset.collectionTitle+(this.anime==='all'?'':' — '+this.select.selectedOptions[0].textContent)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tassilix-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tx-poster-rotator'))customElements.define('tx-poster-rotator',class extends HTMLElement{
  connectedCallback(){if(this.ready)return;this.ready=true;this.slides=[...this.querySelectorAll('.tx-hero-slide')];this.index=0;this.toggle=this.querySelector('button');this.motion=matchMedia('(prefers-reduced-motion: reduce)');if(this.slides.length<2)return;this.playing=!this.motion.matches;this.toggle.hidden=false;this.toggle.addEventListener('click',()=>{this.playing=!this.playing;this.schedule()});this.visibility=()=>this.schedule();document.addEventListener('visibilitychange',this.visibility);this.motionChange=()=>{this.playing=!this.motion.matches;this.schedule()};this.motion.addEventListener('change',this.motionChange);this.schedule()}
  preload(){const img=this.slides[(this.index+1)%this.slides.length].querySelector('img');img.loading='eager';return img}
  schedule(){clearInterval(this.timer);this.toggle.setAttribute('aria-label',this.playing?this.toggle.dataset.pause:this.toggle.dataset.play);this.toggle.querySelector('span').textContent=this.playing?'Ⅱ':'▶';if(this.playing&&!document.hidden){this.preload();this.timer=setInterval(()=>this.advance(),Number(this.dataset.interval)||2000)}}
  async advance(){if(this.changing)return;const next=(this.index+1)%this.slides.length;const img=this.preload();try{await img.decode()}catch{return}if(!this.playing||document.hidden||this.changing)return;this.changing=true;const previous=this.slides[this.index];const incoming=this.slides[next];incoming.hidden=false;incoming.inert=false;previous.inert=true;incoming.style.zIndex='1';if(!this.motion.matches){const options={duration:650,easing:'ease-in-out'};this.fades=[previous.animate([{opacity:1},{opacity:0}],options),incoming.animate([{opacity:0},{opacity:1}],options)];try{await Promise.all(this.fades.map(fade=>fade.finished))}catch{}}previous.hidden=true;incoming.style.removeProperty('z-index');this.index=next;this.changing=false;this.preload()}
  disconnectedCallback(){clearInterval(this.timer);this.fades?.forEach(fade=>fade.cancel());document.removeEventListener('visibilitychange',this.visibility);this.motion?.removeEventListener('change',this.motionChange);this.ready=false}
});

  } catch(e) { console.error(e); }
})();
})();
